import { render, staticRenderFns } from "./QuickAddButtonAddModal.vue?vue&type=template&id=f5b15806"
import script from "./QuickAddButtonAddModal.vue?vue&type=script&lang=ts"
export * from "./QuickAddButtonAddModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5b15806')) {
      api.createRecord('f5b15806', component.options)
    } else {
      api.reload('f5b15806', component.options)
    }
    module.hot.accept("./QuickAddButtonAddModal.vue?vue&type=template&id=f5b15806", function () {
      api.rerender('f5b15806', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/QuickAddButtonAddModal.vue"
export default component.exports